<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useI18n } from 'vue-i18n'
  import VgsSpinner from '@/components/common/VgsSpinner.vue'
  import { aschehougOidcClient } from '@/main'

  const { t } = useI18n()

  onMounted(async () => {
    await aschehougOidcClient.authorize()
  })
</script>

<template>
  <vgs-spinner
    :is-loading="true"
    :aria-label="t('loggingIn')"
  />
</template>
